module.exports = __webpack_public_path__ + "assets/img/12.1421e6be.png";